import { color } from "@ui";

export enum StatusDisplay {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  DEFAULT = "DEFAULT",
}

export const STATUS_BACKGROUNDS = {
  [StatusDisplay.ERROR]: color.errorBackground,
  [StatusDisplay.WARNING]: color.warningBackground,
  [StatusDisplay.SUCCESS]: color.successBackground,
  [StatusDisplay.PENDING]: color.titanium100,
  [StatusDisplay.DEFAULT]: color.hydrogen,
};

export const STATUS_COLORS = {
  [StatusDisplay.ERROR]: color.error,
  [StatusDisplay.WARNING]: color.warning,
  [StatusDisplay.SUCCESS]: color.success,
  [StatusDisplay.PENDING]: color.titanium600,
  [StatusDisplay.DEFAULT]: color.carbon900,
};

export function mapStatusDisplay<T>(entries: [T, StatusDisplay][]) {
  const statusMap = new Map(entries);
  return (status: T): StatusDisplay => statusMap.get(status) ?? StatusDisplay.DEFAULT;
}
